import { WebStorageService } from '@adaptiva/core/storage';
import { IOidcProvider } from '@adaptiva/data-service';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { switchMap, take } from 'rxjs/operators';
import { OidcLandingPage } from '../oidc-landing';

@Component({
	standalone: false,
	selector: 'ada-oidc-register',
	templateUrl: '../oidc-landing/oidc-landing-page.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OidcRegisterComponent extends OidcLandingPage implements OnInit {

	protected readonly tokenParam: string = 'token';

	protected readonly oidcParam: string = 'oidcprovider';

	protected readonly webStorage: WebStorageService = inject(WebStorageService);

	public ngOnInit(): void {
		const _oneTimeCode: string = this.activatedRoute.snapshot.queryParams[this.tokenParam];
		const _oidcProviderId: string = this.activatedRoute.snapshot.queryParams[this.oidcParam];

		if (!_oneTimeCode)
			return this.errorMessage.next('Invalid authentication token. Received: ' + _oneTimeCode);

		if (!_oidcProviderId || isNaN(+_oidcProviderId))
			return this.errorMessage.next('Invalid OIDC Provider ID. Received: ' + _oidcProviderId);

		this.oidc.getOidcProvider(+_oidcProviderId).pipe(
			switchMap((_provider: IOidcProvider) => {
				this.webStorage.setRecord(this.oidc.oneTimeTokenStorage, _oneTimeCode, this.oidc.storageType);

				return this.oidc.sendAuthenticationRequest(_provider, { redirectTo: this.oidc.getRegistrationRedirectUrl() });
			}),
			take(1)
		).subscribe({
			error: (e: Error) => {
				const _message: string = this.logger.extractErrorMessage(e);

				this.errorMessage.next(_message);
				this.logger.error('OidcRedirectComponent.ngOnInit', _message)();
			}
		});
	}

}
